import { useState } from 'react'
import { PLANNER_DAY_LONG, defaultPlannerCalendarContext } from '../../utils/mealPlanHelpers.js'
import Button from '../../design-system/primitives/Button.jsx'
import NightOffPicker from './NightOffPicker.jsx'
import './planner.css'

/**
 * Past planned night that was never marked cooked or skipped.
 * One-tap subtype chips commit a night off; Cooked it / Skipped reuse existing handlers.
 */
export default function PastNightResolveRow({
  meal,
  dayDates = null,
  isToday = false,
  onMarkCooked,
  onMarkSkipped,
  onNightOff,
}) {
  const dates = dayDates ?? defaultPlannerCalendarContext().dayDates
  const dayKey = meal.assignedTo
  const [nightOffType, setNightOffType] = useState(null)

  return (
    <div
      className={[
        'meal-row',
        'assigned',
        'meal-row--resolve',
        isToday ? 'meal-row--today' : '',
      ].filter(Boolean).join(' ')}
    >
      <div className="meal-row-day-chip">
        <div
          className="meal-row-day-chip-bar"
          style={{ background: meal.swatch }}
        />
        <div className="meal-row-day-label">{PLANNER_DAY_LONG[dayKey]}</div>
        <div className="meal-row-day-date">{dates[dayKey]}</div>
        {isToday && <div className="meal-row-today-dot" aria-hidden="true" />}
      </div>

      <div className="meal-row-resolve-body">
        <div className="meal-row-resolve-top">
          <div className="meal-row-resolve-copy">
            <div className="meal-row-name-row">
              <span className="planner-meal-name">{meal.name}</span>
              <span className="meal-row-meta"> · planned, never marked</span>
            </div>
            <p className="meal-row-resolve-question">Did you cook this?</p>
          </div>
          <div className="meal-row-resolve-actions">
            {onMarkCooked && (
              <Button
                variant="primary"
                onClick={() => onMarkCooked()}
              >
                Cooked it
              </Button>
            )}
            {onMarkSkipped && (
              <Button
                variant="secondary"
                onClick={() => onMarkSkipped()}
              >
                Skipped
              </Button>
            )}
          </div>
        </div>
        <div className="meal-row-resolve-night-off">
          <span className="meal-row-resolve-lead">Or it was a night off</span>
          <NightOffPicker
            selected={nightOffType}
            onSelect={setNightOffType}
            commitOnSelect
            onSave={async (typeId) => {
              const ok = await onNightOff?.(typeId)
              if (ok === false) setNightOffType(null)
            }}
          />
        </div>
      </div>
    </div>
  )
}
